import { Link } from "react-router-dom";
import { Trash2, Plus, Minus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { formatGBP } from "../lib/api";

export default function Cart() {
  const { items, updateQty, removeItem, subtotal } = useCart();

  if (items.length === 0) {
    return (
      <main className="max-w-2xl mx-auto px-6 py-32 text-center" data-testid="cart-page-empty">
        <p className="eyebrow text-neutral-500">Your Bag</p>
        <h1 className="font-serif text-4xl md:text-5xl mt-3">A blank slate.</h1>
        <p className="text-neutral-600 mt-4 mb-10 font-light">Begin curating pieces you'll keep forever.</p>
        <Link to="/shop" className="btn-primary">Browse Collection</Link>
      </main>
    );
  }

  return (
    <main className="max-w-[1480px] mx-auto px-6 md:px-12 py-14" data-testid="cart-page">
      <h1 className="font-serif text-4xl md:text-5xl mb-12">Your Bag</h1>
      <div className="grid lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2 divide-y divide-[var(--border)]">
          {items.map((it) => (
            <div key={it.id} className="grid grid-cols-[100px_1fr_auto] gap-6 py-8 items-center" data-testid={`cart-row-${it.id}`}>
              <Link to={`/product/${it.id}`} className="block w-24 h-28 bg-sand">
                <img src={it.image} alt="" className="w-full h-full object-cover" />
              </Link>
              <div>
                <Link to={`/product/${it.id}`} className="font-serif text-xl">{it.name}</Link>
                <p className="text-sm text-neutral-500 mt-1">{formatGBP(it.price)}</p>
                <div className="flex items-center gap-2 mt-4">
                  <button onClick={() => updateQty(it.id, it.quantity - 1)} className="p-2 border border-hair"><Minus className="w-3 h-3" strokeWidth={1.25} /></button>
                  <span className="px-3 text-sm">{it.quantity}</span>
                  <button onClick={() => updateQty(it.id, it.quantity + 1)} className="p-2 border border-hair"><Plus className="w-3 h-3" strokeWidth={1.25} /></button>
                  <button onClick={() => removeItem(it.id)} className="ml-4 text-neutral-500 hover:text-[var(--gold)]"><Trash2 strokeWidth={1.25} className="w-4 h-4" /></button>
                </div>
              </div>
              <p className="font-serif text-lg" data-testid={`row-total-${it.id}`}>{formatGBP(it.price * it.quantity)}</p>
            </div>
          ))}
        </div>
        <aside className="bg-cream border border-hair p-8 self-start">
          <p className="eyebrow text-neutral-600 mb-5">Summary</p>
          <div className="flex justify-between mb-2 text-sm"><span className="text-neutral-600">Subtotal</span><span>{formatGBP(subtotal)}</span></div>
          <p className="text-xs text-neutral-500 mb-6">Shipping calculated at checkout. Free UK delivery on orders over £100.</p>
          <Link to="/checkout" className="btn-primary w-full" data-testid="cart-checkout-btn">Continue to Checkout</Link>
        </aside>
      </div>
    </main>
  );
}
